




















import Vue from "vue";
import { required, minLength } from "vuelidate/lib/validators";

import RoleFormEditor from "../components/RoleFormEditor.vue";
import permission, { PermissionName } from "@/common/mixins/permission";
import dialog from "@/common/mixins/dialog";
import { RoleUpdateForm } from "../forms/RoleUpdateForm";
import { Permission } from "../../permission/models/Permission";

export default Vue.extend({
  mixins: [permission, dialog],
  components: {
    RoleFormEditor
  },
  validations: {
    roleUpdateForm: {
      name: { required },
      selectedPermissions: {
        required,
        minLength: minLength(1)
      }
    }
  },
  data() {
    const permissions: Permission[] = [];
    const roleUpdateForm: RoleUpdateForm = {
      name: "",
      selectedPermissions: []
    };
    return { permissions, roleUpdateForm };
  },
  computed: {
    permissionOptions() {
      return (this as any).permissions;
    },
    hasRoleViewPermission() {
      return (this as any).hasPermission(PermissionName.ROLE_VIEW);
    }
  },
  async created() {
    await Promise.all([
      this.getPermission(),
      this.getRoleById(+this.$route.params.id)
    ]);
  },
  methods: {
    async getPermission() {
      try {
        const {
          data
        } = await (this as any).$dep.permissionUseCase.getPermissions({
          perPage: 9999
        });
        this.permissions = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getRoleById(id: number) {
      try {
        const { data } = await (this as any).$dep.roleUseCase.getRole(id);

        this.roleUpdateForm = {
          ...data,
          selectedPermissions: data.permissions.map(
            (permission: Permission) => permission.id
          )
        };
      } catch (error) {
        console.log(error.response);
      }
    },
    goToRoleViewPage() {
      this.$router.push({ name: "RoleViewPage" });
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to update role",
        "คุณต้องการแก้ไข role หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.updateRole();
      }
    },
    async updateRole() {
      try {
        const role = await (this as any).$dep.roleUseCase.updateRole(
          this.roleUpdateForm
        );
        if (await (this as any).alertSuccess("Success", "แก้ไข Role สำเร็จ")) {
          this.goToRoleViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถแก้ไข Role นี้")
            : (this as any).alertError("Error", error);
        }
      }
    },
    async clear() {
      this.$v.$reset();
      await this.getRoleById(+this.$route.params.id);
    }
  }
});
